import Ajax from "base/Ajax";
import PromiseHelper from "base/PromiseHelper";
import AjaxPageLoader from "../AjaxPageLoader";
import WebsiteModal from "./WebsiteModal";

export default class AjaxLoadedWebsiteModal extends WebsiteModal {

    constructor(url, containerSelector, allowCache = true, settings = {}) {
        super($.extend(true, {}, AjaxLoadedWebsiteModal.default_settings, settings));
        this.url = url;
        this.containerSelector = containerSelector;
        this.allowCache = allowCache;
    }

    loadPageContent() {
        PromiseHelper.short_delayed_promise(AjaxLoadedWebsiteModal.get_page_html(this.url, this.containerSelector, this.allowCache), 500).then(($elem) => {
            this.emit(EVENT_MODAL_CONTENT_LOADED, $elem);

            this.$modal.removeClass(AjaxLoadedWebsiteModal.global_settings.classes.loadingModifier).find(AjaxLoadedWebsiteModal.global_settings.selectors.loadingContainer).remove();
            this.handleContent($elem);

            AjaxPageLoader.fix_html(this.$modal);

            this.emit(EVENT_MODAL_CONTENT_HANDLED, this.$modal);
        }).catch((jqXHR) => {
            console.warn("Couldn't load modal content", jqXHR);
            let error = Ajax.get_ajax_error(jqXHR);
            if (this.emit(EVENT_MODAL_CONTENT_LOADING_FAILED, error)) {
                this.displayError(error);
            }
        });
    }

    displayError(error) {
        this.$modal.removeClass(AjaxLoadedWebsiteModal.global_settings.classes.loadingModifier).find(AjaxLoadedWebsiteModal.global_settings.selectors.loadingContainer).remove();

        let $error;

        if (this.settings.createError) {
            $error = this.settings.createError.call(this, error);
        } else {
            $error = AjaxLoadedWebsiteModal.global_settings.createError.call(this, error);
        }

        this.$modal.find(WebsiteModal.global_settings.selectors.contentContainer).append($error);

    }

    buildElement() {
        this.$modal = AjaxLoadedWebsiteModal.global_settings.buildLoadingModal();

        this.loadPageContent();
    }

    /**
     * @abstract
     * @param $elem
     */
    handleContent($elem) {
        throw new Error("Modal must override handleContent($elem)");
    }

    bindEvents() {
        // Noop
    }


    static get_page_html(url, containerSelector, allowCache = true) {
        let key = btoa(url) + ":" + btoa(containerSelector);

        if (!allowCache || !AjaxLoadedWebsiteModal._get_page_html_promises[key]) {
            let {request} = AjaxPageLoader.get_html(url);

            AjaxLoadedWebsiteModal._get_page_html_promises[key] = request.then((html) => {
                let $html = AjaxPageLoader.parse_html(html);

                let $elem = $html.find(containerSelector);

                let id_prefix = "modal-" + (++MODAL_INDEX) + "-";

                $elem.find("[id]").each((_, el) => {
                    let id = $(el).attr("id");
                    $(el).attr("id", id_prefix + id);
                    $elem.find("[for='" + id + "']").attr("for", id_prefix + id);
                });

                return $elem;
            });

            request.catch((e) => {
                delete AjaxLoadedWebsiteModal._get_page_html_promises[key];
            });
        }

        return AjaxLoadedWebsiteModal._get_page_html_promises[key].then(($element) => $element.clone());
    }
}

AjaxLoadedWebsiteModal.global_settings = {
    classes: {
        loadingModifier: "modal--loading",
        loadingElement: "modal__loading",
        error: "message message--error",
    },
    selectors: {
        loadingContainer: ".js-loading-container",
    },
    createError: function (e) {
        return (
            eotwJSXFactory('div', {className: AjaxLoadedWebsiteModal.global_settings.classes.error}, [
                eotwJSXFactory('p', null, [e.message])
            ])
        );
    },
    buildLoadingModal: function () {
        throw new Error("AjaxLoadedModal.global_settings.buildLoadingModal must be implemented");
    },
};

AjaxLoadedWebsiteModal.default_settings = {
    createError: null,
};

let MODAL_INDEX = 0;
AjaxLoadedWebsiteModal._get_page_html_promises = [];

export const EVENT_MODAL_CONTENT_LOADED = 'contentLoaded';
export const EVENT_MODAL_CONTENT_HANDLED = 'contentHandled';
export const EVENT_MODAL_CONTENT_LOADING_FAILED = 'contentLoadingFailed';
